export default "__VITE_ASSET__D0dDV_gN__"